const ACTION_ITEMS = {
  SELF_ASSESSMENT: {
    DISCIPLINE: {
      SET: 'SELF_ASSESSMENT_DISCIPLINE_SET',
    },
  },
};

export default ACTION_ITEMS;
